import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface CommonCustomConatinerStyles {
    container?: InjectableCss;
}

interface OwnProps {
    // id: string
    children?: React.ReactNode;
    tableType?: any;
}

type Props = OwnProps;
export const CustomCommonTableContainerSyles: CommonCustomConatinerStyles = {
    container: {
        css: css`
            & div table {
                width: 100%;
                border-spacing: 0;
                border-collapse: collapse;
                th {
                    font-size: 15px;
                }

                td {
                    font-size: 13px;
                }
                td,
                th {
                    border-bottom: 1px solid #e1e1e1;
                    padding: 7px 10px;
                    text-align: left;
                }

                tbody tr:last-child {
                    td,
                    th {
                        border-bottom: 0;
                    }
                }
            }

            & div.bordered table {
                border: 1px solid #e1e1e1;
                td,
                th {
                    &:last-child {
                        border-left: 1px solid #e1e1e1;
                    }
                }
            }

            & div.stripped table {
                tr:nth-of-type(2n) {
                    background: #e1e1e1;
                }
            }
        `,
    },
};

const styles = CustomCommonTableContainerSyles;

const CustomCommonTableContainer: React.FC<Props> = ({ children, tableType }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="customTableWrapper">
            <StyledWrapper className={tableType}>{children}</StyledWrapper>
        </StyledWrapper>
    );
};

export default CustomCommonTableContainer;
